// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__mxjn8"};